/**
 * A VideoJS TitleBar whose title is a link back to the media page — the old
 * site's `#m3Link`, rebuilt on the player's own title bar so it inherits the
 * fade-with-the-controls behaviour. Registered under its own name so the
 * built-in TitleBar, and with it the media page, stays untouched.
 *
 * @module components/manage/VideoJS/LinkedTitleBar
 */
import videojs from 'video.js';
import { v4 as uuid } from 'uuid';

const TitleBar = videojs.getComponent('TitleBar');

export const LINKED_TITLE_BAR = 'LinkedTitleBar';

class LinkedTitleBar extends TitleBar {
  // Upstream's structure with an anchor for the title; `updateDom_` fills it
  // with textContent, which works on an anchor unchanged. `options_` is merged
  // by the Component constructor before createEl runs.
  createEl() {
    const { href, linkTitle } = this.options_;

    this.els = {
      title: videojs.dom.createEl(
        href ? 'a' : 'div',
        {
          className: 'vjs-title-bar-title',
          id: `vjs-title-bar-title-${uuid()}`,
        },
        // target=_top: an embed is in an iframe, so without this the media
        // page would open inside the player's own frame.
        href ? { href, target: '_top', rel: 'noopener', title: linkTitle } : {},
      ),
      description: videojs.dom.createEl('div', {
        className: 'vjs-title-bar-description',
        id: `vjs-title-bar-description-${uuid()}`,
      }),
    };

    return videojs.dom.createEl(
      'div',
      { className: 'vjs-title-bar vjs-title-bar-linked' },
      {},
      Object.values(this.els),
    );
  }
}

videojs.registerComponent(LINKED_TITLE_BAR, LinkedTitleBar);

export default LinkedTitleBar;
